export default __webpack_public_path__ + "img/bmBIjadv.bbce0f0b.svg";